<template>
  <div class="btn color-tertiary" @click="showPopup()">
    <span class="d-block"> Как подобрать размер</span>
  </div>
  <teleport to="#product-element__popup-container-vue">
    <transition name="fade">
      <div
        class="popup d-flex d-flex_middle d-flex_center d-flex_column"
        v-if="isShow"
      >
        <div class="popup__layout" @click="closePopup()"></div>
        <div
          class="popup__wrap p-16 p-md-0 scroll scroll_y w-100 active-move-down"
          v-bind:class="{ 'is-active': isAnimate }"
        >
          <div
            class="popup__block bg-white border-radius-xl border-radius-md-0 p-24 p-md-16 mx-auto calc-wrapper"
          >
            <div class="calc relative">
              <div class="calc__close d-none d-md-block absolute">
                <div
                  class="btn color-gray hover-color-dark"
                  @click="closePopup()"
                >
                  <Icon iconName="icon-close" className="icon-24" />
                </div>
              </div>
              <div class="grid-row grid-row_lg d-flex_md-wrap">
                <div class="grid-col grid-col_md-100">
                  <div class="calc-image mx-auto">
                    <svg
                      width="220"
                      height="412"
                      viewBox="0 0 220 412"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M78.8302 398.369C78.8302 398.369 77.527 398.999 76.474 398.369C75.6089 397.851 75.3188 396.483 74.9152 394.579M78.8302 398.369C78.8302 398.369 79.4254 399.629 80.8137 399.629C82.202 399.629 83.0446 399.125 83.0446 399.125M78.8302 398.369C78.8302 398.369 78.0865 396.857 78.8302 394.588M83.0446 399.125C83.0446 399.125 83.5402 400.385 85.5234 400.385C87.5066 400.385 88.2508 399.629 88.2508 399.629M83.0446 399.125C83.0446 399.125 82.3012 397.36 83.0446 394.085M88.2508 399.629C88.2508 399.629 88.7464 400.133 90.2339 400.133C91.7215 400.133 92.7127 399.629 92.7127 399.629M88.2508 399.629C88.2508 399.629 87.5066 398.873 88.003 393.832M92.7127 399.629C92.7127 399.629 93.9525 400.385 96.0588 400.385C98.2898 400.385 100.521 397.613 99.5295 392.068C98.5376 386.524 95.5624 364.344 95.8102 362.076C96.0588 359.807 96.3066 357.035 96.0588 352.751C95.8102 348.466 93.3314 339.644 93.3314 334.604C93.3314 329.563 93.827 279.912 91.596 260.254C89.3651 240.595 92.3402 218.669 93.3314 212.367C94.3234 206.067 94.3234 200.018 94.3234 190.693C94.3234 183.232 98.4145 139.277 96.3066 105.757C96.3066 105.757 99.9775 106.781 102.382 106.765C104.785 106.781 108.456 105.757 108.456 105.757C106.348 139.277 110.439 183.232 110.439 190.693C110.439 200.018 110.439 206.067 111.431 212.367C112.422 218.669 115.397 240.595 113.166 260.254C110.935 279.912 111.431 329.563 111.431 334.604C111.431 339.644 108.952 348.466 108.704 352.751C108.456 357.035 108.704 359.807 108.952 362.076C109.2 364.344 106.225 386.524 105.234 392.068C104.242 397.613 106.473 400.385 108.704 400.385C110.81 400.385 112.05 399.629 112.05 399.629M92.7127 399.629C92.7127 399.629 91.3832 399.125 92.4649 396.101C93.4569 393.328 92.9605 391.312 92.9605 391.312M74.8637 394.337C74.2867 391.623 73.7818 387.895 74.4908 384.003C75.4824 378.559 80.195 364.093 80.3181 361.572C80.4404 359.052 78.7051 354.968 78.7051 352.751C78.7051 350.533 80.4428 347.206 80.3181 344.937C80.1926 342.669 58.875 277.896 57.2625 260.254C55.7714 243.94 63.335 210.099 63.335 204.554C63.335 200.119 62.1781 190.777 61.5996 186.66C58.8727 155.156 47.4692 130.204 43.9984 103.237C40.5278 76.2688 45.4852 61.463 49.2044 52.0735C60.4853 23.5936 58.502 12 58.502 12M74.8637 394.337L74.9152 394.579M74.8637 394.337C74.8811 394.418 74.8983 394.499 74.9152 394.579M125.932 398.369C125.932 398.369 127.235 398.999 128.288 398.369C129.153 397.851 129.444 396.483 129.847 394.579M125.932 398.369C125.932 398.369 125.337 399.629 123.949 399.629C122.56 399.629 121.718 399.125 121.718 399.125M125.932 398.369C125.932 398.369 126.676 396.857 125.932 394.588M121.718 399.125C121.718 399.125 121.222 400.385 119.239 400.385C117.256 400.385 116.512 399.629 116.512 399.629M121.718 399.125C121.718 399.125 122.461 397.36 121.718 394.085M116.512 399.629C116.512 399.629 116.016 400.133 114.528 400.133C113.041 400.133 112.05 399.629 112.05 399.629M116.512 399.629C116.512 399.629 117.256 398.873 116.759 393.832M112.05 399.629C112.05 399.629 113.379 399.125 112.297 396.101C111.305 393.328 111.802 391.312 111.802 391.312M129.899 394.337C130.476 391.623 130.981 387.895 130.272 384.003C129.28 378.559 124.567 364.093 124.445 361.572C124.322 359.052 126.057 354.968 126.057 352.751C126.057 350.533 124.32 347.206 124.445 344.937C124.57 342.669 145.888 277.896 147.5 260.254C148.991 243.94 141.427 210.099 141.427 204.554C141.427 200.119 142.584 190.777 143.163 186.66C145.89 155.156 157.293 130.204 160.764 103.237C164.235 76.2688 158.781 61.6508 155.558 52.0735C144.277 23.5936 146.26 12 146.26 12M129.899 394.337L129.847 394.579M129.899 394.337C129.882 394.418 129.864 394.499 129.847 394.579M91.2251 203.042C91.2251 203.042 91.1266 208.234 89.7383 210.856C87.7552 214.6 87.2588 223.205 87.2588 223.205M77.5907 211.611C77.5907 211.611 78.3344 214.383 77.0949 217.912M73.8721 196.237C73.8721 196.237 76.1033 200.522 76.1033 206.822M113.537 203.042C113.537 203.042 113.636 208.234 115.024 210.856C117.008 214.6 117.504 223.205 117.504 223.205M127.172 211.611C127.172 211.611 126.428 214.383 127.667 217.912M130.89 196.237C130.89 196.237 128.659 200.522 128.659 206.822"
                        stroke="#009AA6"
                        stroke-width="1.73285"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M102.36 60.911C86.5392 60.911 59.0878 57.024 49.7906 49.8052C48.0788 54.3762 46.6007 59.0353 45.3623 63.7637C51.2282 72.7385 66.5407 79.5201 75.8379 86.2253C84.8841 92.7429 89.3603 98.3232 96.1009 106.472C99.3723 108.187 105.537 108.187 108.808 106.472C115.543 98.3232 119.835 92.7429 128.882 86.2253C138.18 79.5201 153.492 72.7385 159.399 63.7637C158.152 59.0371 156.672 54.3783 154.963 49.8052C145.633 57.017 118.181 60.911 102.36 60.911Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M104.612 84.1084C106.1 88.897 102.133 89.6531 102.133 87.1328"
                        stroke="#009AA6"
                        stroke-width="1.08177"
                        stroke-linecap="round"
                      />
                      <path
                        d="M93.8793 395.344C94.8705 394.28 97.6169 393.966 98.1173 395.289C98.6176 396.61 92.8873 396.406 93.8793 395.344Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M88.9287 395.54C89.2249 394.637 91.1215 394.424 91.6553 395.288C92.1898 396.152 88.6324 396.444 88.9287 395.54Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M83.8409 395.944C84.2404 395.035 86.2132 394.829 86.8152 395.747C87.4173 396.665 83.4406 396.853 83.8409 395.944Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M79.8199 395.541C79.9708 394.733 81.7022 394.516 82.2026 395.541C82.7029 396.565 79.669 396.348 79.8199 395.541Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M76.248 395.54C76.3907 394.829 78.1882 394.425 78.231 395.54C78.2738 396.655 76.1053 396.252 76.248 395.54Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M110.691 395.344C109.699 394.28 106.953 393.966 106.453 395.289C105.953 396.61 111.682 396.406 110.691 395.344Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M115.643 395.54C115.346 394.637 113.45 394.424 112.916 395.288C112.382 396.152 115.939 396.444 115.643 395.54Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M120.73 395.944C120.329 395.035 118.357 394.829 117.755 395.747C117.153 396.665 121.13 396.853 120.73 395.944Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M124.751 395.541C124.6 394.733 122.869 394.516 122.368 395.541C121.868 396.565 124.902 396.348 124.751 395.541Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M128.323 395.54C128.18 394.829 126.382 394.425 126.339 395.54C126.297 396.655 128.465 396.252 128.323 395.54Z"
                        fill="#009AA6"
                      />
                      <path
                        d="M70.3892 334.625L70.9272 334.031L70.3892 334.625ZM99.5173 334.625L98.9796 334.031L99.5173 334.625ZM73.1767 332.649C73.6027 332.542 73.8633 332.105 73.7587 331.672C73.6542 331.239 73.2242 330.974 72.7982 331.08L73.1767 332.649ZM97.1625 330.967C96.736 330.863 96.3071 331.13 96.2046 331.564C96.1022 331.997 96.3651 332.433 96.7916 332.537L97.1625 330.967ZM84.7408 337.976C85.0561 337.665 85.0633 337.154 84.7583 336.834L79.784 331.615C79.4791 331.295 78.9759 331.287 78.6609 331.597C78.3459 331.908 78.338 332.419 78.6433 332.739L83.065 337.378L78.5022 341.873C78.1871 342.183 78.1792 342.694 78.4845 343.015C78.7898 343.335 79.2926 343.343 79.6077 343.033L84.7408 337.976ZM88.9049 336.485C88.4673 336.512 88.1337 336.895 88.1607 337.34C88.1869 337.785 88.5634 338.124 89.0018 338.097L88.9049 336.485ZM70.9272 334.031C70.6795 333.799 70.684 333.696 70.6861 333.724C70.6903 333.784 70.6465 333.759 70.7802 333.631C70.9223 333.496 71.1859 333.328 71.6104 333.148C72.0257 332.973 72.551 332.805 73.1767 332.649L72.7982 331.08C72.1232 331.249 71.5147 331.44 71.0006 331.657C70.4958 331.87 70.0344 332.129 69.6935 332.454C69.3442 332.787 69.0592 333.256 69.1019 333.844C69.1422 334.399 69.4644 334.857 69.8514 335.219L70.9272 334.031ZM96.7916 332.537C97.4261 332.692 97.9559 332.86 98.3721 333.037C98.7978 333.219 99.0559 333.39 99.1901 333.526C99.2528 333.589 99.2727 333.628 99.2775 333.64C99.2799 333.645 99.2791 333.645 99.2783 333.641C99.2783 333.637 99.2783 333.635 99.2783 333.635C99.2775 333.639 99.256 333.773 98.9796 334.031L100.056 335.219C100.461 334.839 100.793 334.376 100.856 333.822C100.925 333.226 100.663 332.734 100.307 332.377C99.9661 332.034 99.4975 331.766 98.9868 331.548C98.4658 331.326 97.8479 331.134 97.1625 330.967L96.7916 332.537ZM84.2007 336.588C81.1978 336.541 78.2531 336.28 75.8459 335.824C74.6419 335.596 73.5881 335.322 72.7357 335.009C71.87 334.692 71.2723 334.354 70.9272 334.031L69.8514 335.219C70.4236 335.755 71.2506 336.181 72.1959 336.528C73.1544 336.88 74.2975 337.174 75.5552 337.412C78.0714 337.888 81.1088 338.154 84.1753 338.203L84.2007 336.588ZM98.9796 334.031C98.3371 334.633 97.0592 335.188 95.2357 335.625C93.4471 336.054 91.255 336.34 88.9049 336.485L89.0018 338.097C91.4083 337.949 93.6965 337.653 95.5994 337.197C97.4682 336.75 99.0932 336.119 100.056 335.219L98.9796 334.031Z"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 1,
                          'is-noactive':
                            activeStep === 2 ||
                            activeStep === 3 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M47.7496 259.138L47.2228 259.743L47.7496 259.138ZM99.8741 259.138L99.3476 258.534L99.8741 259.138ZM53.2009 255.025C53.6294 254.93 53.9013 254.5 53.808 254.064C53.7147 253.629 53.2917 253.352 52.8631 253.447L53.2009 255.025ZM95.7148 253.45C95.2875 253.347 94.8594 253.615 94.7578 254.05C94.6569 254.483 94.9206 254.918 95.3471 255.022L95.7148 253.45ZM75.2209 264.494C75.5301 264.177 75.5285 263.666 75.2174 263.352L70.1469 258.23C69.8358 257.916 69.3329 257.917 69.0237 258.234C68.7145 258.549 68.7162 259.061 69.0273 259.375L73.5343 263.929L69.0558 268.51C68.7466 268.827 68.7482 269.338 69.0594 269.653C69.3705 269.967 69.8734 269.965 70.1826 269.649L75.2209 264.494ZM79.3879 263.005C78.9497 263.025 78.6101 263.402 78.6294 263.847C78.6487 264.293 79.0197 264.638 79.4578 264.618L79.3879 263.005ZM48.2764 258.534C47.7533 258.063 47.6581 257.753 47.6541 257.606C47.6508 257.484 47.7068 257.259 48.1002 256.931C48.9206 256.248 50.6617 255.587 53.2009 255.025L52.8631 253.447C50.3238 254.009 48.2378 254.729 47.0936 255.682C46.5047 256.173 46.0441 256.829 46.0662 257.651C46.0877 258.449 46.56 259.145 47.2228 259.743L48.2764 258.534ZM95.3471 255.022C96.4677 255.292 97.4192 255.59 98.1769 255.911C98.9457 256.235 99.4635 256.562 99.7653 256.865C100.052 257.153 100.088 257.354 100.068 257.505C100.041 257.702 99.8861 258.049 99.3476 258.534L100.401 259.743C101.065 259.145 101.54 258.474 101.642 257.723C101.749 256.925 101.408 256.244 100.881 255.715C100.371 255.203 99.6383 254.779 98.7869 254.419C97.9243 254.055 96.8863 253.734 95.7148 253.45L95.3471 255.022ZM74.655 263.117C68.8835 263.136 63.078 262.731 58.293 261.933C55.9 261.535 53.778 261.04 52.0502 260.457C50.306 259.87 49.0327 259.216 48.2764 258.534L47.2228 259.743C48.2195 260.641 49.7349 261.379 51.5505 261.99C53.3825 262.608 55.5916 263.12 58.0359 263.527C62.926 264.342 68.8215 264.751 74.6601 264.732L74.655 263.117ZM99.3476 258.534C97.9918 259.755 95.3439 260.789 91.7683 261.56C88.234 262.323 83.9285 262.801 79.3879 263.005L79.4578 264.618C84.054 264.412 88.4524 263.926 92.0979 263.14C95.7029 262.362 98.7122 261.263 100.401 259.743L99.3476 258.534Z"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 2,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 3 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M39.9774 120.599L40.5219 120.011L39.9774 120.599ZM102.067 120.599L101.522 120.011L102.067 120.599ZM43.2031 116.116C43.6166 115.966 43.8332 115.505 43.6868 115.084C43.5404 114.665 43.0866 114.444 42.6731 114.593L43.2031 116.116ZM100.333 114.659C99.9265 114.49 99.4634 114.689 99.2974 115.101C99.1314 115.514 99.3268 115.986 99.7327 116.154L100.333 114.659ZM42.7946 115.407L43.0653 116.166L42.7946 115.407ZM70.4467 127.226C70.7606 126.914 70.7669 126.403 70.4606 126.084L65.4691 120.882C65.1628 120.563 64.66 120.557 64.346 120.868C64.0321 121.179 64.0258 121.691 64.3321 122.01L68.769 126.633L64.2209 131.145C63.9069 131.456 63.9007 131.967 64.207 132.286C64.5133 132.605 65.0161 132.612 65.3301 132.3L70.4467 127.226ZM74.6392 125.816C74.2006 125.825 73.8534 126.195 73.8634 126.641C73.8735 127.087 74.2372 127.44 74.6757 127.43L74.6392 125.816ZM99.7327 116.154C101.306 116.806 102.11 117.47 102.363 118.031C102.471 118.271 102.489 118.514 102.391 118.807C102.284 119.123 102.027 119.527 101.522 120.011L102.612 121.186C103.226 120.598 103.674 119.982 103.893 119.331C104.121 118.655 104.089 117.982 103.807 117.357C103.28 116.189 101.948 115.328 100.333 114.659L99.7327 116.154ZM40.5219 120.011C40.029 119.538 39.8138 119.158 39.7422 118.878C39.6785 118.628 39.7109 118.396 39.871 118.133C40.0463 117.846 40.3815 117.517 40.9329 117.169C41.478 116.825 42.1911 116.488 43.0653 116.166L42.5238 114.648C41.5855 114.993 40.7632 115.374 40.0942 115.797C39.4314 116.217 38.8737 116.704 38.521 117.282C38.153 117.886 38.0224 118.569 38.2046 119.283C38.3789 119.966 38.8184 120.598 39.4329 121.186L40.5219 120.011ZM43.0653 116.166C43.1108 116.149 43.1568 116.132 43.2031 116.116L42.6731 114.593C42.623 114.611 42.5732 114.629 42.5238 114.648L43.0653 116.166ZM69.9019 125.841C63.3788 125.758 56.9377 125.197 51.6489 124.189C49.0041 123.686 46.6634 123.074 44.7517 122.362C42.8267 121.645 41.398 120.849 40.5219 120.011L39.4329 121.186C40.5373 122.243 42.199 123.132 44.2054 123.878C46.2252 124.63 48.6569 125.263 51.3565 125.777C56.7565 126.805 63.2922 127.372 69.8822 127.455L69.9019 125.841ZM101.522 120.011C99.7176 121.739 96.0776 123.141 91.2384 124.136C86.4469 125.12 80.634 125.675 74.6392 125.816L74.6757 127.43C80.7332 127.288 86.6439 126.727 91.5529 125.719C96.4152 124.72 100.454 123.252 102.612 121.186L101.522 120.011Z"
                        v-if="isTightsOrStokings()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 3,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M108.802 116.162C108.367 116.162 108.015 116.478 108.015 116.867C108.015 117.256 108.367 117.572 108.802 117.572V116.162ZM179.257 117.572C179.692 117.572 180.044 117.256 180.044 116.867C180.044 116.478 179.692 116.162 179.257 116.162V117.572ZM130.057 370.714C129.622 370.714 129.269 371.03 129.269 371.419C129.269 371.808 129.622 372.124 130.057 372.124V370.714ZM179.257 372.124C179.692 372.124 180.044 371.808 180.044 371.419C180.044 371.03 179.692 370.714 179.257 370.714V372.124ZM179.814 122.009C179.507 121.734 179.008 121.734 178.701 122.009L173.691 126.497C173.383 126.772 173.383 127.219 173.691 127.494C173.998 127.769 174.497 127.769 174.804 127.494L179.257 123.505L183.71 127.494C184.017 127.769 184.516 127.769 184.824 127.494C185.131 127.219 185.131 126.772 184.824 126.497L179.814 122.009ZM178.701 366.277C179.008 366.552 179.507 366.552 179.814 366.277L184.824 361.789C185.131 361.514 185.131 361.067 184.824 360.792C184.516 360.516 184.017 360.516 183.71 360.792L179.257 364.781L174.804 360.792C174.497 360.516 173.998 360.516 173.691 360.792C173.383 361.067 173.383 361.514 173.691 361.789L178.701 366.277ZM108.802 117.572H179.257V116.162H108.802V117.572ZM130.057 372.124H179.257V370.714H130.057V372.124ZM178.47 122.508V365.778H180.044V122.508H178.47Z"
                        v-if="isTightsOrStokings()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 4,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 3,
                        }"
                      />
                      <path
                        d="M203.321 223.553C194.11 223.553 186.643 231.144 186.643 240.509C186.643 249.874 194.11 257.466 203.321 257.466C212.533 257.466 220 249.874 220 240.509C220 231.144 212.533 223.553 203.321 223.553Z"
                        v-if="isTightsOrStokings()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 4,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 3,
                        }"
                      />
                      <path
                        d="M186.643 257.466V240.509L203.321 257.466H186.643Z"
                        v-if="isTightsOrStokings()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 4,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 3,
                        }"
                      />
                      <path
                        d="M23.0322 223.553C32.2436 223.553 39.7109 231.144 39.7109 240.509C39.7109 249.874 32.2436 257.466 23.0322 257.466C13.8208 257.466 6.35351 249.874 6.35351 240.509C6.35351 231.144 13.8208 223.553 23.0322 223.553Z"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 2,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 3 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M39.6787 297C48.8901 297 56.3574 304.592 56.3574 313.957C56.3574 323.321 48.8901 330.913 39.6787 330.913C30.4673 330.913 23 323.321 23 313.957C23 304.592 30.4673 297 39.6787 297Z"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 1,
                          'is-noactive':
                            activeStep === 2 ||
                            activeStep === 3 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M39.7109 257.466V240.509L23.0322 257.466H39.7109Z"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 2,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 3 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M56.3574 330.913V313.957L39.6787 330.913H56.3574Z"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 1,
                          'is-noactive':
                            activeStep === 2 ||
                            activeStep === 3 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M16.6787 82.2486C25.8901 82.2486 33.3574 89.8403 33.3574 99.2051C33.3574 108.57 25.8901 116.162 16.6787 116.162C7.46731 116.162 -6.52813e-07 108.57 -1.4581e-06 99.2051C-2.26338e-06 89.8403 7.4673 82.2486 16.6787 82.2486Z"
                        v-if="isTightsOrStokings()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 3,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M33.3574 116.162V99.2051L16.6787 116.162H33.3574Z"
                        v-if="isTightsOrStokings()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 3,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 4,
                        }"
                      />
                      <path
                        d="M30.1281 251.835H16.8561V248.811L23.1001 243.239C24.0895 242.343 24.8455 241.494 25.3681 240.691C25.9095 239.87 26.1801 239.011 26.1801 238.115V237.751C26.1801 236.799 25.8908 236.053 25.3121 235.511C24.7521 234.97 23.9868 234.699 23.0161 234.699C22.4748 234.699 21.9988 234.783 21.5881 234.951C21.1961 235.101 20.8508 235.315 20.5521 235.595C20.2535 235.875 20.0015 236.202 19.7961 236.575C19.6095 236.949 19.4601 237.35 19.3481 237.779L16.5761 236.715C16.7815 236.099 17.0615 235.511 17.4161 234.951C17.7708 234.373 18.2188 233.859 18.7601 233.411C19.3015 232.963 19.9361 232.609 20.6641 232.347C21.4108 232.086 22.2788 231.955 23.2681 231.955C24.2575 231.955 25.1441 232.105 25.9281 232.403C26.7121 232.683 27.3655 233.085 27.8881 233.607C28.4295 234.111 28.8401 234.718 29.1201 235.427C29.4001 236.137 29.5401 236.911 29.5401 237.751C29.5401 238.535 29.4188 239.263 29.1761 239.935C28.9335 240.607 28.5975 241.242 28.1681 241.839C27.7388 242.437 27.2348 243.006 26.6561 243.547C26.0961 244.089 25.4988 244.639 24.8641 245.199L20.2721 249.147H30.1281V251.835Z"
                        fill="white"
                      />
                      <path
                        d="M34.0906 325.283V322.651H39.5786V308.035H39.3546L34.8186 312.879L32.8866 311.143L37.8706 305.739H42.6866V322.651H47.4466V325.283H34.0906Z"
                        fill="white"
                      />
                      <path
                        d="M15.9001 99.1844C17.1135 99.1844 18.0095 98.9324 18.5881 98.4284C19.1668 97.9057 19.4561 97.243 19.4561 96.4404V96.2444C19.4561 95.3484 19.1761 94.667 18.6161 94.2004C18.0561 93.715 17.3001 93.4724 16.3481 93.4724C15.4148 93.4724 14.6215 93.687 13.9681 94.1164C13.3148 94.527 12.7641 95.1057 12.3161 95.8524L10.2161 94.0324C10.5148 93.603 10.8508 93.1924 11.2241 92.8004C11.5975 92.4084 12.0361 92.0724 12.5401 91.7924C13.0441 91.4937 13.6135 91.2604 14.2481 91.0924C14.8828 90.9057 15.6108 90.8124 16.4321 90.8124C17.3468 90.8124 18.1961 90.9244 18.9801 91.1484C19.7641 91.3724 20.4361 91.7084 20.9961 92.1564C21.5561 92.5857 21.9948 93.1177 22.3121 93.7524C22.6295 94.3684 22.7881 95.0684 22.7881 95.8524C22.7881 96.4684 22.6855 97.0284 22.4801 97.5324C22.2935 98.0364 22.0228 98.4844 21.6681 98.8764C21.3321 99.2497 20.9308 99.5577 20.4641 99.8004C20.0161 100.043 19.5401 100.22 19.0361 100.332V100.472C19.5961 100.584 20.1188 100.771 20.6041 101.032C21.1081 101.275 21.5468 101.602 21.9201 102.012C22.2935 102.404 22.5828 102.88 22.7881 103.44C23.0121 103.982 23.1241 104.607 23.1241 105.316C23.1241 106.175 22.9561 106.959 22.6201 107.668C22.2841 108.359 21.8081 108.956 21.1921 109.46C20.5948 109.964 19.8668 110.356 19.0081 110.636C18.1495 110.898 17.1975 111.028 16.1521 111.028C15.2375 111.028 14.4348 110.926 13.7441 110.72C13.0535 110.534 12.4375 110.282 11.8961 109.964C11.3735 109.628 10.9068 109.255 10.4961 108.844C10.1041 108.415 9.75879 107.976 9.46013 107.528L11.7841 105.708C12.0268 106.1 12.2788 106.464 12.5401 106.8C12.8201 107.118 13.1281 107.398 13.4641 107.64C13.8188 107.864 14.2108 108.042 14.6401 108.172C15.0881 108.303 15.5921 108.368 16.1521 108.368C17.3468 108.368 18.2615 108.088 18.8961 107.528C19.5308 106.95 19.8481 106.156 19.8481 105.148V104.952C19.8481 103.944 19.5121 103.179 18.8401 102.656C18.1681 102.134 17.2161 101.872 15.9841 101.872H13.9121V99.1844H15.9001Z"
                        fill="white"
                        v-if="isTightsOrStokings()"
                      />
                      <path
                        d="M203.782 250.907V247.099H194.71V244.383L202.634 231.363H206.778V244.607H209.438V247.099H206.778V250.907H203.782ZM197.398 244.607H203.782V234.247H203.586L197.398 244.607Z"
                        fill="white"
                        v-if="isTightsOrStokings()"
                      />
                      <path
                        d="M108.802 216.162C108.367 216.162 108.015 216.478 108.015 216.867C108.015 217.256 108.367 217.572 108.802 217.572V216.162ZM179.257 217.572C179.692 217.572 180.044 217.256 180.044 216.867C180.044 216.478 179.692 216.162 179.257 216.162V217.572ZM130.057 370.714C129.622 370.714 129.269 371.03 129.269 371.419C129.269 371.808 129.622 372.124 130.057 372.124V370.714ZM179.257 372.124C179.692 372.124 180.044 371.808 180.044 371.419C180.044 371.03 179.692 370.714 179.257 370.714V372.124ZM179.814 221.504C179.507 221.229 179.008 221.229 178.701 221.504L173.691 225.992C173.383 226.267 173.383 226.714 173.691 226.989C173.998 227.265 174.497 227.265 174.804 226.989L179.257 223L183.71 226.989C184.017 227.265 184.516 227.265 184.824 226.989C185.131 226.714 185.131 226.267 184.824 225.992L179.814 221.504ZM178.701 366.277C179.008 366.552 179.507 366.552 179.814 366.277L184.824 361.789C185.131 361.514 185.131 361.067 184.824 360.792C184.516 360.516 184.017 360.516 183.71 360.792L179.257 364.781L174.804 360.792C174.497 360.516 173.998 360.516 173.691 360.792C173.383 361.067 173.383 361.514 173.691 361.789L178.701 366.277ZM108.802 217.572H179.257V216.162H108.802V217.572ZM130.057 372.124H179.257V370.714H130.057V372.124ZM178.47 222.003V365.778H180.044V222.003H178.47Z"
                        v-if="isGolfSocks()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 4,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 3,
                        }"
                      />
                      <path
                        d="M203.321 261.553C194.11 261.553 186.643 269.144 186.643 278.509C186.643 287.874 194.11 295.466 203.321 295.466C212.533 295.466 220 287.874 220 278.509C220 269.144 212.533 261.553 203.321 261.553Z"
                        v-if="isGolfSocks()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 4,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 3,
                        }"
                      />
                      <path
                        d="M186.643 295.466V278.509L203.321 295.466H186.643Z"
                        v-if="isGolfSocks()"
                        class="calc-step"
                        :class="{
                          'is-active': activeStep === 4,
                          'is-noactive':
                            activeStep === 1 ||
                            activeStep === 2 ||
                            activeStep === 3,
                        }"
                      />
                      <path
                        d="M201.066 277.399C202.279 277.399 203.175 277.147 203.754 276.643C204.333 276.12 204.622 275.457 204.622 274.655V274.459C204.622 273.563 204.342 272.881 203.782 272.415C203.222 271.929 202.466 271.687 201.514 271.687C200.581 271.687 199.787 271.901 199.134 272.331C198.481 272.741 197.93 273.32 197.482 274.067L195.382 272.247C195.681 271.817 196.017 271.407 196.39 271.015C196.763 270.623 197.202 270.287 197.706 270.007C198.21 269.708 198.779 269.475 199.414 269.307C200.049 269.12 200.777 269.027 201.598 269.027C202.513 269.027 203.362 269.139 204.146 269.363C204.93 269.587 205.602 269.923 206.162 270.371C206.722 270.8 207.161 271.332 207.478 271.967C207.795 272.583 207.954 273.283 207.954 274.067C207.954 274.683 207.851 275.243 207.646 275.747C207.459 276.251 207.189 276.699 206.834 277.091C206.498 277.464 206.097 277.772 205.63 278.015C205.182 278.257 204.706 278.435 204.202 278.547V278.687C204.762 278.799 205.285 278.985 205.77 279.247C206.274 279.489 206.713 279.816 207.086 280.227C207.459 280.619 207.749 281.095 207.954 281.655C208.178 282.196 208.29 282.821 208.29 283.531C208.29 284.389 208.122 285.173 207.786 285.883C207.45 286.573 206.974 287.171 206.358 287.675C205.761 288.179 205.033 288.571 204.174 288.851C203.315 289.112 202.363 289.243 201.318 289.243C200.403 289.243 199.601 289.14 198.91 288.935C198.219 288.748 197.603 288.496 197.062 288.179C196.539 287.843 196.073 287.469 195.662 287.059C195.27 286.629 194.925 286.191 194.626 285.743L196.95 283.923C197.193 284.315 197.445 284.679 197.706 285.015C197.986 285.332 198.294 285.612 198.63 285.855C198.985 286.079 199.377 286.256 199.806 286.387C200.254 286.517 200.758 286.583 201.318 286.583C202.513 286.583 203.427 286.303 204.062 285.743C204.697 285.164 205.014 284.371 205.014 283.363V283.167C205.014 282.159 204.678 281.393 204.006 280.871C203.334 280.348 202.382 280.087 201.15 280.087H199.078V277.399H201.066Z"
                        fill="white"
                        v-if="isGolfSocks()"
                      />
                    </svg>
                  </div>
                </div>

                <div class="grid-col grid-col_full grid-col_md-100">
                  <form class="calc-form">
                    <div class="grid-row grid-row_md">
                      <div class="grid-col grid-col_full">
                        <div class="fs-20 fw-semibold">
                          Подберите идеальный размер в
                          <span v-if="isTightsOrStokings()">4</span>
                          <span v-if="isGolfSocks()">3</span>
                          простых шага
                        </div>
                      </div>
                      <div class="grid-col d-md-none">
                        <div
                          class="btn color-gray hover-color-dark"
                          @click="closePopup()"
                        >
                          <Icon iconName="icon-close" className="icon-24" />
                        </div>
                      </div>
                    </div>

                    <div class="mt-20">
                      Точные измерения - ключ к идеальной посадке. Следуйте
                      нашим простым инструкциям для подбора размера, который
                      подойдет именно вам.
                    </div>

                    <div
                      class="calc-item mt-16 border-radius-md py-8"
                      :class="{ 'is-active': activeStep === 1 }"
                      @click="activeStep = 1"
                    >
                      <div class="grid-row grid-row_md d-flex_sm-wrap">
                        <div class="grid-col grid-col_full grid-col_sm-100">
                          <span class="fw-medium">Шаг 1:</span> Начнём с
                          щиколотки — измерьте самую тонкую часть вашей ноги
                        </div>

                        <div class="grid-col grid-col_sm-100 pt-sm-16">
                          <input
                            type="text"
                            class="calc-input form-field"
                            placeholder="~19-32 см"
                            autocomplete="off"
                            v-model="size_a"
                            pattern="[0-9]{2}"
                            inputmode="numeric"
                            @input="saveSizeInStore()"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      class="calc-item mt-16 border-radius-md py-8"
                      :class="{ 'is-active': activeStep === 2 }"
                      @click="activeStep = 2"
                    >
                      <div class="grid-row grid-row_md d-flex_sm-wrap">
                        <div class="grid-col grid-col_full grid-col_sm-100">
                          <span class="fw-medium">Шаг 2:</span> Теперь голень —
                          найдите самую широкую часть, отступив 5 см вниз от
                          колена
                        </div>

                        <div class="grid-col grid-col_sm-100 pt-sm-16">
                          <input
                            type="text"
                            class="calc-input form-field"
                            placeholder="~28-50 см"
                            autocomplete="off"
                            v-model="size_b"
                            pattern="[0-9]{2}"
                            inputmode="numeric"
                            @input="saveSizeInStore()"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      class="calc-item mt-16 border-radius-md py-8"
                      :class="{ 'is-active': activeStep === 3 }"
                      @click="activeStep = 3"
                      v-if="isTightsOrStokings()"
                    >
                      <div class="grid-row grid-row_md d-flex_sm-wrap">
                        <div class="grid-col grid-col_full grid-col_sm-100">
                          <span class="fw-medium">Шаг 3:</span> Измерим
                          окружность бедра — отмерьте 5 см вниз от паховой
                          складки
                        </div>

                        <div class="grid-col grid-col_sm-100 pt-sm-16">
                          <input
                            type="text"
                            class="calc-input form-field"
                            placeholder="~42-85 см"
                            autocomplete="off"
                            v-model="size_c"
                            pattern="[0-9]{2}"
                            inputmode="numeric"
                            @input="saveSizeInStore()"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      class="calc-item mt-16 border-radius-md py-8"
                      :class="{ 'is-active': activeStep === 4 }"
                      @click="activeStep = 4"
                    >
                      <div class="grid-row grid-row_md d-flex_sm-wrap">
                        <div class="grid-col grid-col_full grid-col_sm-100">
                          <span class="fw-medium" v-if="isTightsOrStokings()">
                            Шаг 4:
                          </span>
                          <span class="fw-medium" v-if="isGolfSocks()">
                            Шаг 3:
                          </span>
                          <span v-if="isTightsOrStokings()">
                            И наконец, длина — измерьте расстояние от пятки до
                            точки на 5 см ниже паховой складки по внутренней
                            стороне ноги
                          </span>
                          <span v-if="isGolfSocks()">
                            И наконец, длина — измерьте расстояние по внутренней
                            стороне ноги от колена до пятки
                          </span>
                        </div>

                        <div class="grid-col grid-col_sm-100 pt-sm-16">
                          <input
                            type="text"
                            class="calc-input form-field"
                            placeholder="~62-83 см"
                            autocomplete="off"
                            v-model="size_d"
                            pattern="[0-9]{2}"
                            inputmode="numeric"
                            @input="saveSizeInStore()"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-20 text-center"
                      id="calc-buttons-success"
                      v-if="offerId > 0"
                    >
                      <button
                        class="btn btn_mbl btn_px-lg border-radius-md btn_fill-tertiary w-md-100"
                        @click="applyOffer"
                        type="button"
                      >
                        Подобрать размер
                      </button>
                    </div>

                    <div
                      class="mt-24"
                      id="calc-total-not-successful"
                      v-if="offerId === 0"
                    >
                      <div class="grid-row grid-row_md d-flex_middle">
                        <div class="grid-col">
                          <Icon
                            iconName="icon-info-fill"
                            className="icon-20 color-tertiary"
                          />
                        </div>
                        <div
                          class="grid-col grid-col_full color-tertiary"
                          v-if="allSizeEntered === false"
                        >
                          Заполните все данные, если возникли вопросы,
                          воспользуйтесь видеоконсультацией
                        </div>
                        <div
                          class="grid-col grid-col_full color-tertiary"
                          v-if="offerId === 0 && allSizeEntered === true"
                        >
                          Для ваших параметров необходим индивидуальный подбор.
                          Свяжитесь с оператором или обратитесь в ближайший
                          ортопедический салон ОРТЕКА
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-16"
                      id="calc-total-success"
                      v-show="offerId > 0"
                    >
                      <div class="pt-8" v-if="this.getOfferData?.size?.name">
                        Ваш размер:
                        <span
                          class="fw-bold fs-18"
                          id="size"
                          v-text="this.getOfferData?.size?.name"
                        ></span>
                      </div>

                      <div
                        class="pt-8"
                        v-if="this.getOfferData?.props?.polnota?.value?.name"
                      >
                        Голень:
                        <span
                          class="fw-bold fs-18"
                          id="polnota"
                          v-text="
                            this.getOfferData?.props?.polnota?.value?.name
                          "
                        ></span>
                      </div>

                      <div
                        class="pt-8"
                        v-if="this.getOfferData?.props?.dlina?.value?.name"
                      >
                        Длина:
                        <span
                          class="fw-bold fs-18"
                          id="dlina"
                          v-text="this.getOfferData?.props?.dlina?.value?.name"
                        ></span>
                      </div>

                      <div
                        class="зе-8"
                        v-if="
                          !isGolfSocks() &&
                          this.getOfferData?.props?.shirina?.value?.name
                        "
                      >
                        Ширина бедра:
                        <span
                          class="fw-bold fs-18"
                          id="shirina"
                          v-text="
                            this.getOfferData?.props?.shirina?.value?.name
                          "
                        ></span>
                      </div>
                    </div>

                    <div class="mt-24 text-center">
                      <button
                        class="btn color-gray hover-color-hover-primary"
                        @click.prevent="openVideoCall()"
                      >
                        <span class="d-block icon-20 mr-8">
                          <svg>
                            <use
                              xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg#icon-camera-security"
                            ></use>
                          </svg>
                        </span>
                        <span class="d-block">
                          Мне необходима видеоконсультация
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import { useMktCalculatorStore } from "@/pages/product_card/stores/store_mkt_calculator";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { ref } from "vue";

export default {
  name: "PopupCalculatorMkt",
  components: {
    // MainProvider,
    Icon,
  },
  setup() {
    const storeMktCalculator = useMktCalculatorStore();
    const productStore = useProductStore();

    return {
      storeMktCalculator,
      productStore,
    };
  },
  data() {
    return {
      isShow: false,
      isAnimate: false,
      polnota_id: 0,
      razmer_id: 0,
      dlina_id: 0,
      shirina_id: 0,
      screenWidth: ref(screen.width),
      activeStep: 0,
      offerId: 0,
      allSizeEntered: false,
    };
  },
  methods: {
    isTightsOrStokings() {
      return ["колготки", "чулки"].includes(this.vidTovara);
    },
    isGolfSocks() {
      return this.vidTovara === "гольфы";
    },
    applyOffer() {
      if (!this.offerId) {
        return;
      }

      this.productStore.selectedOfferId = this.offerId;
      this.productStore.setOffer(String(this.offerId));
      this.closePopup();
    },
    clearData() {
      this.offerId = 0;
      this.polnota_id = 0;
      this.razmer_id = 0;
      this.dlina_id = 0;
      this.shirina_id = 0;
      this.size_a = "";
      this.size_b = "";
      this.size_c = "";
      this.size_d = "";
      this.activeStep = 0;
    },
    showPopup() {
      document.documentElement.classList.add("is-fixed");
      this.isShow = true;
      this.clearData();
      this.storeMktCalculator.sizes.size_c = 0;
      this.storeMktCalculator.sizes.size_d = 0;
      setTimeout(() => {
        this.isAnimate = true;
      }, 2);
    },
    closePopup() {
      this.allSizeEntered = false;
      document.documentElement.classList.remove("is-fixed");
      this.isAnimate = false;
      setTimeout(() => {
        this.isShow = false;
      }, 150);
    },
    saveSizeInStore() {
      this.storeMktCalculator.sizes.size_a = this.size_a;
      this.storeMktCalculator.sizes.size_b = this.size_b;
      this.storeMktCalculator.sizes.size_c = this.size_c;
      this.storeMktCalculator.sizes.size_d = this.size_d;

      this.allSizeEntered = true;
      for (let size in this.storeMktCalculator.sizes) {
        if (
          this.storeMktCalculator.sizes[size] === undefined ||
          this.storeMktCalculator.sizes[size] === ""
        ) {
          if ((size === "size_c" && this.vidTovara !== "колготки") === false) {
            this.allSizeEntered = false;
            break;
          }
        }
      }
      if (this.allSizeEntered === true) {
        this.storeMktCalculator
          .getMktData(
            this.storeMktCalculator.sizes,
            this.productStore.getOffersId
          )
          .then((response) => {
            if (
              response.data[0].success === true &&
              this.productStore.getOffersId.includes(response.data[0].offer)
            ) {
              this.offerId = Number(response.data[0].offer);
            } else {
              this.offerId = 0;
            }
          });
      }
    },
    openVideoCall() {
      document.documentElement.classList.remove("is-fixed");
      this.isShow = false;
      window.openCallPopup();
    },
  },
  computed: {
    getOfferData() {
      let offerID = this.offerId;
      let offer = this.productStore.offers.filter((offer) => {
        return Number(offer.id) === Number(offerID);
      });

      return offer[0];
    },
    vidTovara() {
      return this.productStore.getProductVidTovara;
    },
  },
};
</script>

<style lang="scss">
@import "./popup.scss";
</style>
